import { formatIconImg, formatImgCash, formatTags } from './formatters';
import { formatTableAttr } from './formatters/attributes';
import { RPGLink, RPGTypes } from './formatters/types';
import type { Options, PokerGameTile, SeatFinderType } from './types';
import { ePoolBlockGameTypeCollection } from './types';

const mapSeatFinderType = (
  {
    staticData: {
      id,
      clubId,
      game,
      structure,
      maxPlayersPerTable,
      ante,
      cap,
      minChipsLimit,
      maxBuyIn,
      currency,
      tableStakes: { blinds, stakes },
      isHiLo,
      flags2,
      isPM,
      scalePM,
      server,
      serverObj,
      loBet,
      hiBet
    },
    lastEntry
  }: SeatFinderType,
  { language }: Options
): PokerGameTile => ({
  id,
  clubId,
  type: RPGTypes.CASH_GAME,
  link: RPGLink.SEAT_FINDER,
  imageUrl: formatImgCash(game, structure, maxBuyIn, cap, Number(isHiLo), flags2),
  imageUrlV2: formatImgCash(game, structure, maxBuyIn, cap, Number(isHiLo), flags2, true),
  tags: formatTags({
    game,
    structure,
    maxPerTable: maxPlayersPerTable,
    ante,
    cap,
    tableFlags2: flags2,
    isHiLo: Boolean(isHiLo)
  }),
  attributes: formatTableAttr(
    {
      minChipsLimit,
      maxBuyIn,
      blinds,
      currency,
      ante,
      flags2,
      game,
      stakes,
      isPlayMoney: isPM,
      structure,
      scalePM,
      loBet,
      hiBet
    },
    language
  ),
  lastEntry,
  iconUrl: formatIconImg(RPGTypes.CASH_GAME),
  server,
  serverObj,
  ePoolBlockGameType: ePoolBlockGameTypeCollection.seatFinder,
  isPlayMoney: Boolean(isPM) // isPlayMoney could be a number (0/1)
});

const mapSeatFinderTypeFn = (
  seatFinderTypes: SeatFinderType[],
  options: Options
): PokerGameTile[] => seatFinderTypes.map((type) => mapSeatFinderType(type, options));

export default mapSeatFinderTypeFn;
